var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5C8.5 8.03043 8.71071 8.53914 9.08579 8.91421C9.46086 9.28929 9.96957 9.5 10.5 9.5C11.0304 9.5 11.5391 9.28929 11.9142 8.91421C12.2893 8.53914 12.5 8.03043 12.5 7.5C12.5 6.96957 12.2893 6.46086 11.9142 6.08579C11.5391 5.71071 11.0304 5.5 10.5 5.5C9.96957 5.5 9.46086 5.71071 9.08579 6.08579C8.71071 6.46086 8.5 6.96957 8.5 7.5Z",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5C17.1 11.5 14.1 13.5 10.5 13.5C6.9 13.5 3.9 11.5 1.5 7.5C3.9 3.5 6.9 1.5 10.5 1.5C14.1 1.5 17.1 3.5 19.5 7.5Z",
    stroke: "#CACACA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEyeIcon);
export default __webpack_public_path__ + "static/media/table-eye-icon.e0202d95917ac1b6e49655219b1c6989.svg";
export { ForwardRef as ReactComponent };